
const SET_CUSTOM_GROUPING: string = 'SET_CUSTOM_GROUPING';

export const CUSTOM_GROUPING_ACTION_TYPES = {
    SET_CUSTOM_GROUPING,
};